import {
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

import BackButton from '@components/BackButton';

export enum ButtonType {
  Menu,
  Back,
  None,
}

const Content = styled(IonContent)`
  --padding-top: 5px;
`;

type Props = {
  id?: string;
  /**
   * The title that will be shown in the header.
   */
  title: string | ReactElement;
  /**
   * Whether to show a border on the bottom of the header.
   */
  showHeaderBorder?: boolean;
  /**
   * Wrap the children in IonContent. If you disable this, you need to wrap it yourself or
   * the element will not scroll and may be positioned incorrectly.
   */
  wrapContent?: boolean;
  children: ReactNode;
  /**
   * Content that will be shown in an IonFooter.
   */
  footer?: ReactNode;
  /**
   * What type of nav button (menu, back, or none) should be shown in the header.
   */
  buttonType?: ButtonType;
};

const Layout = ({
  id = undefined,
  title,
  wrapContent = true,
  footer = null,
  showHeaderBorder = false,
  buttonType = ButtonType.Menu,
  children,
}: Props) => (
  <IonPage id={id}>
    <IonHeader className={showHeaderBorder ? '' : 'ion-no-border'}>
      <IonToolbar>
        <IonButtons slot="start">
          {buttonType === ButtonType.Back && <BackButton />}
          {buttonType === ButtonType.Menu && <IonMenuButton auto-hide="false" color="primary" />}
        </IonButtons>
        <IonTitle>{title}</IonTitle>
      </IonToolbar>
    </IonHeader>
    {wrapContent ? <Content fullscreen>{children}</Content> : children}
    {footer && <IonFooter>{footer}</IonFooter>}
  </IonPage>
);

export default Layout;
